import styled, { css } from "styled-components"

const StyledHeroSection = styled.section`
  padding: 11rem 1.6rem 8rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  ${({ theme }) => theme.mq.small} {
    max-width: 96rem;
    margin: 0 auto;
    padding: 15rem 1.6rem 14rem;
  }
`

const PlayerWrapper = styled.div`
  max-width: 96rem;
  max-height: 54rem;
  margin-top: 1.6rem;

  ${({ theme }) => theme.mq.medium} {
    margin-top: 5.6rem;
  }
`

const paragraphStyles = css`
  font-size: ${({ theme }) => theme.font.size.l};
  line-height: 1.71;
  max-width: 70rem;
  margin-top: 1.6rem;

  ${({ theme }) => theme.mq.medium} {
    margin-top: 2.4rem;
  }
`

// Preserves the original h2 visual size (font-family/weight/size/line-height
// as rendered by GlobalStyles' h2 tag selector + mixins.h2Sizes) now that
// this heading is semantically an h1 (the About page's only page heading).
const headerStyles = css`
  font-family: ${({ theme }) => theme.font.family.headers};
  font-weight: 700;
  font-size: 3.2rem;
  line-height: 4rem;

  ${({ theme }) => theme.mq.medium} {
    font-size: 4.8rem;
    line-height: 6rem;
  }
`

// Visually hides the heading from sighted users while keeping it in the
// accessible DOM order, so the page's heading hierarchy stays valid
// (h1 -> h2 -> h3/h4) without any visual change.
const visuallyHiddenStyles = css`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`

export {
  StyledHeroSection,
  PlayerWrapper,
  paragraphStyles,
  headerStyles,
  visuallyHiddenStyles,
}
